import { Loop } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { Activity } from "api/types";
import { ActivityCard } from "components/ActivityCard";
import { StyledButton } from "components/StyledButton";

export interface ActivityResultsProps {
	selected: Activity[];
	handler: (activity: Activity[]) => void;
	activities: Activity[];
	page: number;
	setPage: (page: number) => void;
}

export const ActivityResults = (props: ActivityResultsProps): JSX.Element => {
	const { selected, handler, activities, page, setPage } = props;

	const handleClick = (item: Activity): void => {
		if (!selected.includes(item)) {
			handler([...selected, item]);
		}
	};
	const loadMore = (): void => {
		setPage(page + 1);
	};

	const Pagination = (): JSX.Element =>
		page >= 0 ? (
			<StyledButton color="primary" onClick={loadMore} startIcon={<Loop />}>
				Load More
			</StyledButton>
		) : (
			<Typography variant="subtitle1" align="center">
				No more activities to show
			</Typography>
		);

	return (
		<>
			<Box
				display="grid"
				gap={2}
				gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))"
			>
				{activities.map((item) => (
					<Box key={`${item.questId} ${item.activityType} ${item.name}`}>
						<ActivityCard
							activity={item}
							handler={handleClick}
							selected={selected}
						/>
					</Box>
				))}
			</Box>
			<Grid container justifyContent="center">
				{activities.length > 0 && <Pagination />}
			</Grid>
		</>
	);
};
